export default __webpack_public_path__ + "static/media/Hair_2_M_C5.5fee56fb.svg";